import MaterialApproveForm from './components/MaterialApproveForm/MaterialApproveForm';

const ApprovalFormResolver: React.FC = () => {
  return (
    <div>
      <MaterialApproveForm />
    </div>
  );
};

export default ApprovalFormResolver;
